import { ReactComponent as Logo } from 'assets/logo/svg/shopify-logo.svg';
import { Box, useToken } from '@chakra-ui/react';

const ShopifyLogo = ({ colorKey = 'gray.400', ...props }) => {
  // Use Chakra UI's color token
  const [color] = useToken('colors', [colorKey]);

  return (
    <Box
      as={Logo}
      style={{ fill: color }}
 
      
      {...props}
    />
  );
};

export default ShopifyLogo;
